import { Link } from "react-router-dom";
import { ArrowRight, Award } from "lucide-react";

export default function FinalCta() {
  const toForm = () => document.getElementById("quick-match")?.scrollIntoView({ behavior: "smooth", block: "start" });
  return (
    <section className="py-16 md:py-24 bg-[#FAF7EE]" data-testid="home-final-cta">
      <div className="max-w-7xl mx-auto px-5 md:px-10 space-y-5">
        <div className="relative overflow-hidden rounded-3xl bg-[#0F2A1F] text-white p-8 md:p-14">
          <div aria-hidden className="absolute inset-0 hero-glow opacity-80" />
          <div className="relative max-w-2xl">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight">Your next paycheck could start <span className="text-[#D4AF37] italic">at your kitchen table.</span></h2>
            <p className="mt-4 text-white/70 text-base md:text-lg">Employers are reviewing candidates this week. Take 30 seconds and get in the queue.</p>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <button onClick={toForm} className="h-14 px-7 rounded-xl bg-[#D4AF37] text-[#0F2A1F] font-bold inline-flex items-center justify-center gap-2 hover:bg-[#e2bf48] transition-colors" data-testid="final-cta-match">
                Get matched now <ArrowRight className="h-5 w-5" />
              </button>
              <Link to="/jobs" className="h-14 px-7 rounded-xl ring-1 ring-white/25 font-semibold inline-flex items-center justify-center hover:bg-white/10 transition-colors" data-testid="final-cta-browse">Browse open roles</Link>
            </div>
          </div>
        </div>
        <div className="grid md:grid-cols-2 gap-5">
          <div className="rounded-2xl bg-white p-6 md:p-8 ring-1 ring-[#0F2A1F]/10" data-testid="home-prc-card">
            <Award className="h-6 w-6 text-[#D4AF37]" />
            <h3 className="mt-3 text-2xl font-bold text-[#0F2A1F]">New to payroll or admin? Get certified free.</h3>
            <p className="mt-2 text-sm text-[#0F2A1F]/65">Our 7- or 14-day Payroll Readiness Certificate gets graduates priority matching.</p>
            <Link to="/enroll" className="mt-5 inline-flex items-center gap-1.5 text-sm font-bold text-[#0F2A1F] hover:underline" data-testid="prc-enroll-btn">Learn about PRC <ArrowRight className="h-4 w-4" /></Link>
          </div>
          <div className="rounded-2xl bg-white p-6 md:p-8 ring-1 ring-[#0F2A1F]/10" data-testid="home-employer-cta">
            <div className="text-[11px] tracking-[0.25em] uppercase text-[#0F2A1F]/55 font-bold">For employers</div>
            <h3 className="mt-3 text-2xl font-bold text-[#0F2A1F]">Hiring? Get a vetted, remote-ready shortlist.</h3>
            <Link to="/for-employers" className="mt-5 inline-flex items-center gap-1.5 text-sm font-bold text-[#0F2A1F] hover:underline" data-testid="employer-cta-btn">Request a shortlist <ArrowRight className="h-4 w-4" /></Link>
          </div>
        </div>
      </div>
    </section>
  );
}
